export const handleKeyDown = (validation: any, event: React.KeyboardEvent<HTMLInputElement>) => {
  const allowedKeys = ["Backspace", "Delete", "Tab", "Enter", "Escape"];
  // If negative numbers are not allowed, prevent minus sign
  if (event.key === "-" && !validation?.allowNegative) {
    event.preventDefault();
    return;
  }

  // Allow minus sign only at the start of input when negative is allowed
  if (event.key === "-" && validation?.allowNegative) {
    if (event.currentTarget.selectionStart !== 0 || event.currentTarget.value.includes("-")) {
      event.preventDefault();
      return;
    }
  }
  // Allow decimal point only if decimals are allowed
  if (event.key === "." && !validation?.allowDecimals) {
    event.preventDefault();
    return;
  }

  // Allow numeric keys
  if (/^\d$/.test(event.key)) {
    // Check max length
    if (validation?.maxLength && event.currentTarget.value.length >= validation.maxLength) {
      event.preventDefault();
      return;
    }
    return;
  }

  // Prevent other keys unless they're in allowedKeys
  if (!allowedKeys.includes(event.key)) {
    event.preventDefault();
  }
};
